/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React, { useRef } from "react";
import styles from "./Filter.module.css";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import cx from "classnames";
import HelpOutline from "@material-ui/icons/HelpOutline";
import Tooltip from "./../../../Tooltip/Tooltip";
import { constant } from "./../../../shared/constants/constants";
import { updateUserFilterValue } from "./../../../store/actions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const useStyles = makeStyles((theme) => ({
  formCtrl: {
    width: "200px",
  },
  iconCont: {
    color: "grey",
    marginLeft: "12px",
  },
}));

// User selection filter
const UserFilter = () => {
  const dispatch = useDispatch();
  const list = useRef([]);
  const isLoading = useSelector((state) => state.ui.isLoading, shallowEqual);
  const jobType = useSelector((state) => state.geoUtil.jobType, shallowEqual);
  const user = useSelector((state) => state.geoUtil.user, shallowEqual);
  const userList = useSelector((state) => state.user.users);
  const contractorList = useSelector((state) => state.user.contractors);


  // handle any changes happen in user dropdown
  const handleChange = (event) => {
    if (event.target.value === user.userId) return;
    dispatch(
      updateUserFilterValue({
        userId: event.target.value,
        name: event.currentTarget.innerText,
      })
    );
  };

  const classes = useStyles();

  if (jobType === "" || jobType === "unassigned_jobs") return null;
  list.current = jobType === "technician_jobs" ? userList : contractorList;
  return (
    <div className={cx(styles.FilterCont, styles.MT12, styles.JSTCtr)}>
      <FormControl className={classes.formCtrl}>
        <Select
          disableUnderline
          disabled={isLoading}
          displayEmpty
          value={user.userId}
          onChange={handleChange}>
          <MenuItem value="">
            {jobType === "technician_jobs"
              ? constant.TECHNICIANS
              : constant.CONTRACTORS}
          </MenuItem>
          {list.current.map((item) => (
            <MenuItem
              key={item.id}
              value={jobType === "technician_jobs" ? item.userId : item.id}
              name={item.name}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Tooltip
        className={classes.iconCont}
        title={constant.USER_FILTER_DESC}
        arrow>
        <HelpOutline />
      </Tooltip>
    </div>
  );
};

export default React.memo(UserFilter);
